import { ImpersonationFilterScreen, useSlideLayout } from '@gripp/shared-ui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const ImpersonationWorkspaceFiltersColumn = () => {
  const { t } = useTranslation();
  const { setColumnTitle } = useSlideLayout();

  useEffect(() => {
    setColumnTitle(t('common.filter'));
    return () => setColumnTitle(undefined);
  }, [setColumnTitle, t]);

  return <ImpersonationFilterScreen />;
};
